import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  FDStack,
  FDAccordion,
  FDAccordionTitle,
  FDAccordionDetails,
  FDLozenge,
  FDPrimaryActionButton, FDBox,
} from '@facet-wealth/design';
import { Box } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import { useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import fr from 'facet-rest';
import {
  OwnAndOweChecklistItemGroup,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingAssetsAndLiabilitiesAdd/OnboardingAssetsAndLiabilitiesAddContent/OwnAndOweChecklistItemGroup';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import useMobileLayout from 'Hooks/useMobileLayout';
import { dataAttrs } from 'Helpers/Testing';

const OwnAndOweChecklist = ({ resource }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const checklistItemGroups = resource.attr('checklistItemGroups').resources().list();
  const theme = useTheme();
  const { loadModalCollectionByLink } = useModalContext();
  const isMobile = useMobileLayout();

  if (checklistItemGroups.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.facet.accentBlue21,
        border: `1px solid ${theme.palette.facet.oceana200}`,
        borderRadius: theme.spacing(2),
      }}
    >
      <FDAccordion
        expansionID="own-and-owe-checklist"
        expanded={isExpanded}
        onChange={() => setIsExpanded(!isExpanded)}
        {...dataAttrs('own-and-owe-checklist')}
      >
        <FDAccordionTitle>
          <FDStack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            width="100%"
            spacing={1}
          >
            <FDStack direction={isMobile ? 'column' : 'row'} spacing={isMobile ? 2 : 4}>
              <Text text={resource.attr('checklistItemsTitle')} weight={'extraBold'} variant={'h5'} align={'left'} color={'secondaryText'} />
              <FDLozenge
                color={resource.attr('checklistItemsStatus')}
                label={resource.attr('checklistItemsStatusLabel')}
                alignSelf={isMobile ? 'flex-start' : 'center'}
              />
            </FDStack>
            {resource.withRelationship(fr.relationships.missingItems.name,
              (rel) => (
                <FDBox paddingX={2}>
                  <FDPrimaryActionButton
                    size={'sm'}
                    onClick={() => {
                      loadModalCollectionByLink(rel.link('related').url());
                    }}
                    label={rel.meta('prompt')}
                    {...dataAttrs('missing-items-button')}
                  />
                </FDBox>
              ),
              () => null)}
          </FDStack>
        </FDAccordionTitle>
        <FDAccordionDetails>
          <FDStack
            direction={isMobile ? 'column' : 'row'}
            justifyContent="space-between"
            spacing={isMobile ? 2 : 1}
            width="100%"
          >
            {checklistItemGroups.map((group) => (
              <OwnAndOweChecklistItemGroup key={group.id()} checklistItemGroupResource={group} />
            ))}
          </FDStack>
        </FDAccordionDetails>
      </FDAccordion>
    </Box>
  );
};

OwnAndOweChecklist.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export { OwnAndOweChecklist };
